<template>
  <div class="main-container wrapper bg-grey-lightest">
    <div class="main-content-wrap">
      <div class="main-content-pannel">
        <div
          class="option-wrap bg-grey-lightest grey-bg-option no-border"
          style="height: 100px"
        >
          <div class="options">
            <div class="breadcrumb">
              <a href="javascript:void(0);" @click="goBack"
                ><i class="material-icons align-middle">chevron_left</i>
                Projects</a
              >
            </div>
            <div class="content-title-wrap p-t-0">
              <div class="main-content-title">
                {{ project ? project.title : "" }}
              </div>
            </div>
          </div>
        </div>
        <div class="main-flex" v-if="project">
          <div class="main-flex-1">
            <div class="pannel-1">
              <div class="pannel-1-title">
                <h3>Task</h3>
              </div>
              <div class="pannel-1-body project-detail-task">
                <p class="preline" v-html="project.task" />
                <h6>
                  <i class="material-icons-outlined align-middle"
                    >account_balance</i
                  >Client Description:
                </h6>
                <p class="preline" v-html="project.client_description" />
              </div>
              <div v-if="project.roles && project.roles.length > 0">
                <div
                  v-for="(role, index) in project.roles"
                  :key="index"
                  class="relative"
                >
                  <div class="hr"></div>
                  <div class="pannel-1-title">
                    <div>
                      <h3 class="cursor-default">
                        {{ role.title }}
                      </h3>
                    </div>
                  </div>
                  <div class="pannel-1-body project-detail-task">
                    <p class="preline" v-html="role.requirements" />
                    <p
                      class="inline"
                      v-if="
                        role.hours_per_week !== null &&
                        role.hours_per_week !== undefined
                      "
                    >
                      <label
                        ><i class="material-icons align-middle"
                          >perm_contact_calendar</i
                        >Hours Weekly</label
                      >
                      {{ role.hours_per_week ? role.hours_per_week : "" }}/week
                    </p>
                  </div>
                  <div class="deal-size">
                    <p class="font-color-lighter font-sm line-height-20">
                      Assuming 4 weeks per month
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="main-flex-1">
            <div v-for="(role, index) in project.roles" :key="index">
              <div v-if="index !== 0" class="hr m-t-l m-b-l"></div>
              <div class="pannel-out-title">
                <h3>{{ role.title }}</h3>
              </div>
              <div
                v-if="
                  showConsultants &&
                  showConsultants[role.id] &&
                  showConsultants[role.id].length > 0
                "
              >
                <div
                  class="pannel-1 pannel-1-padding relative action-wrapper"
                  v-for="(consultant, cIndex) in showConsultants[role.id]"
                  :key="cIndex"
                >
                  <div class="pannel-1-title">
                    <div style="width: 100%">
                      <h3>
                        <div
                          class="use-wrapper"
                          @click="toResume(consultant.id, $event)"
                        >
                          <div class="avatar">
                            <span v-if="!consultant.photo_url">{{
                              (consultant.name
                                ? consultant.name
                                : consultant.email) | getFirstLetter
                            }}</span>
                            <img v-else :src="consultant.photo_url" alt />
                          </div>
                          <div class="user-name">{{ consultant.name }}</div>
                        </div>
                        <i
                          class="material-icons align-middle font-color-lighter"
                          v-if="
                            (consultant.client_confirm ||
                              consultant.reply === 'yes') &&
                            !(
                              consultant.client_confirm &&
                              consultant.reply === 'yes'
                            )
                          "
                          >check</i
                        >
                        <i
                          class="material-icons align-middle font-color-lighter"
                          v-if="
                            consultant.client_confirm &&
                            consultant.reply === 'yes'
                          "
                          >done_all</i
                        >
                        <i
                          class="material-icons align-middle font-color-green"
                          v-if="consultant.verified"
                          >verified</i
                        >
                        <div
                          class="pannel-1-title-option"
                          v-if="consultant.role_rate_to_client"
                        >
                          <span>{{
                            consultant.role_rate_to_client
                              | currencyFilter("$", 2)
                          }}</span
                          >/hr
                        </div>
                      </h3>
                    </div>
                  </div>
                  <div class="hr"></div>
                  <div>
                    <div class="pannel-1-body p-b-0">
                      <p>{{ consultant.bio }}</p>
                    </div>
                    <div class="pannel-1-footer">
                      <div>
                        <span class="tech_lvl_tag"
                          ><i class="material-icons align-middle">stream</i
                          >{{ consultant.tech_level }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <transition name="edit-pannel">
        <edit-pannel v-model="editOpen" @input="closeEditPannel" title>
          <ProjectPanel
            v-if="editOpen == 2"
            :propsData="project"
            :projectPhaseOptions="projectPhaseOptions"
            @closePanel="closeEditPannel"
          ></ProjectPanel>
          <RolePanel
            v-if="editOpen == 3"
            :propsData="{ id: project.id, roles: project.roles }"
            :roleId="editRoleId"
            @closePanel="closeEditPannel"
          ></RolePanel>
        </edit-pannel>
      </transition>
    </div>
  </div>
</template>

<script>
import EditPannel from "@/components/EditPannel";
import OptionMenu from "@/components/OptionMenu";
import ProjectPanel from "./ProjectPanel.vue";
import RolePanel from "./RolePanel.vue";

export default {
  props: ["project", "editOpenTitle", "projectPhaseOptions", "consultants"],
  data() {
    return {
      editOpen: false,
      editRoleId: null,
      showConsultants: {},
    };
  },
  components: {
    EditPannel,
    OptionMenu,
    ProjectPanel,
    RolePanel,
  },
  watch: {
    editOpenTitle: function (val) {
      this.editOpen = val;
    },
    consultants: function () {
      this.initShowConsultants();
    },
  },
  mounted() {
    this.initShowConsultants();
  },
  methods: {
    goBack: function () {
      this.$emit("clickItem", null);
    },
    editProject: function () {
      this.openEditPannel(2, "Edit Project", true);
    },
    editRole: function (index) {
      this.editRoleId = index;
      this.openEditPannel(3, "Edit Role", true);
    },
    addRole: function () {
      this.editRoleId = null;
      this.openEditPannel(3, "Add Role", true);
    },
    openEditPannel: function (action, title, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        this.emitEditPannel(title);
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
      this.emitEditPannel(title);
    },
    closeEditPannel: function () {
      this.editOpen = false;
      this.emitEditPannel();
    },
    emitEditPannel: function (title) {
      const param = {
        title: title,
        editOpen: this.editOpen,
      };
      this.$emit("pannelEvent", param);
    },
    initShowConsultants: function () {
      this.showConsultants = {};
      const selectedConsultants = this.project.selected_consultants;
      if (selectedConsultants) {
        selectedConsultants.forEach((item) => {
          const roleId = item.role_id;
          const consultants = item.consultants;
          if (roleId && consultants) {
            const slectedConsultants = [];
            consultants.forEach((item) => {
              const consultant = this.consultants.find((c) => c.id === item.id);
              if (consultant && item.status === "Submitted") {
                slectedConsultants.push({ ...consultant, ...item });
              }
            });
            slectedConsultants.sort(this.sortRoleStatus);
            this.showConsultants[roleId] = slectedConsultants;
          }
        });
      }
    },
    toResume: function (id, event) {
      event.stopPropagation();
      const routeData = this.$router.resolve({
        path: `/resume/${id}/ano`,
        query: { id },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>


<style scoped>
.use-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.user-name {
  color: var(--blue-light);
}
.user-name:hover {
  text-decoration: underline;
}
</style>
